<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <section v-if="!isLoading" class="orders">
      <div class="container">
        <div class="row justify-content-md-center mb-2">
          <img class="top-img" src="@/assets/svg/Ardunic Elements-08.svg" />
          <div class="title ml-4">
            <h1>Your</h1>
            <h1>Orders</h1>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col">
            <div class="table-card">
              <table class="table table-borderless table-sm">
                <thead>
                  <tr>
                    <th
                      class="tbotn"
                      style="  background: linear-gradient(to right, #05cefc, #5659ce);
"
                      scope="col"
                    >
                      Order ID
                    </th>
                    <th
                      class="tbotn"
                      style="   background: linear-gradient(to right, #ff3fbb, #ff8891);"
                      scope="col"
                    >
                      Order Date
                    </th>
                    <th
                      class="tbotn"
                      style="    background: linear-gradient(to right, #46ad68, #05f040);

"
                      scope="col"
                    >
                      Items
                    </th>
                    <th
                      class="tbotn"
                      style="    background: linear-gradient(to right, #05cefc, #107add);
"
                      scope="col"
                    >
                      Units
                    </th>
                    <th
                      class="tbotn"
                      style="  background: linear-gradient(to right, #ff4800, #fcaa15);
"
                      scope="col"
                    >
                      Total
                    </th>
                    <th
                      class="tbotn"
                      style="  background:linear-gradient(to right, #004a99, #0087a6);
"
                      scope="col"
                    >
                      Status
                    </th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" v-bind:key="order._id">
                    <th scope="row">{{ order._id }}</th>
                    <td>{{ formatDate(order.createdAt) }}</td>
                    <td>{{ order.orderItem.length }}</td>
                    <td>{{ order.totalQuantities }}</td>
                    <td>
                      {{ order.totalPriceAfterDiscount | toCurrency }} IQD
                    </td>
                    <td>{{ statusType[order.status] }}</td>
                    <td>
                      <button
                        v-if="order.status !== 0"
                        @click="print(order)"
                        class="btn btn-info btn-sm btn-rounded"
                      >
                        Print invoice
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav class="mt-2" aria-label="Page navigation example">
              <ul class="pagination justify-content-end">
                <li class="page-item">
                  <a class="page-link" @click="previous">Previous</a>
                </li>
                <li class="page-item">
                  <a class="page-link" @click="next">Next</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section v-if="showPrintingPage" class="printing-section">
      <div @click="closePrint" class="invoice-box overflow-y">
        <table cellpadding="0" cellspacing="0">
          <tr class="top">
            <td colspan="2">
              <table>
                <tr>
                  <td class="title">
                    <img
                      src="@/assets/f9215686-be33-4a6e-bf6a-0c1bf8e402b1.png"
                      style="width: 30%; max-width: 300px"
                    />
                  </td>

                  <td>
                    <h2>Order Number: {{ order._id }}</h2>
                    <br />
                    Date:
                    {{ new Date(order.createdAt).toLocaleString().split(",")[0]
                    }}<br />
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr class="information">
            <td colspan="2">
              <table>
                <tr>
                  <td style="font-size: 18px">
                    <span
                      style="
                              font-size: 20px;
                              font-weight: bold;
                              border-bottom: 1px solid gray;
                              padding-bottom: 5px;
                              margin-bottom: 15px;
                            "
                      >Shipping Data</span
                    ><br />
                    {{ order.location.address }}<br />
                    {{ order.location.province }}<br />
                    {{ order.location.city }}<br />
                  </td>

                  <td style="font-size: 18px">
                    <span
                      style="
                              font-size: 20px;
                              font-weight: bold;
                              border-bottom: 1px solid gray;
                              padding-bottom: 5px;
                              margin-bottom: 15px;
                            "
                      >Personal Data</span
                    ><br />
                    {{ user.name }}<br />
                    {{ user.phone }}<br />
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr class="heading">
            <td>Payment Method</td>

            <td>Cash on Delivery</td>
          </tr>

          <tr class="details">
            <td>Delivery Price</td>

            <td>
              {{ order.location.transportPrice }}
            </td>
          </tr>

          <tr class="heading">
            <td>
              # - SKU - &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; Item
            </td>

            <td>Price</td>
          </tr>

          <tr
            v-for="(product, index) in order.orderItem"
            :key="product._id"
            class="item"
          >
            <td>
              <span style="font-weight: bold">{{ index + 1 }} - </span>
              {{ product.product.serialNumber }} - &nbsp; &nbsp;
              {{ product.product.title }}
              <span v-if="product.product.types.value" style="font-weight: bold"
                >-- {{ product.product.types.groupName }}:
                {{ product.product.types.value }}</span
              >
            </td>

            <td>
              {{ product.price / product.quantity }} IQD<span
                class="ml-2 text-muted"
                >x {{ product.quantity }}</span
              >
            </td>
          </tr>

          <tr class="total">
            <td></td>

            <td>Subtotal: {{ order.totalPrice }} IQD</td>
          </tr>
          <tr class="total">
            <td></td>

            <td>
              Dilivery/Handeling:
              {{ order.location.transportPrice }} IQD
            </td>
          </tr>
          <tr v-if="order.promo.code" class="total">
            <td></td>
            <td style="color: red">
              Discount:
              {{
                order.totalPrice -
                  ((100 - order.promo.discountPercentage) / 100) *
                    order.totalPrice
              }}
              IQD
            </td>
          </tr>
          <tr v-if="order.promo.code" class="total">
            <td></td>

            <td>Total: {{ order.totalPriceAfterPromoDiscount }} IQD</td>
          </tr>
          <tr v-if="!order.promo.code" class="total">
            <td></td>
            <td>Total: {{ order.totalPriceAfterDiscount }} IQD</td>
          </tr>
        </table>

        <div v-if="order.orderNotes != 'ملاحظة'">
          <span
            style="
                    font-size: 20px;
                    font-weight: bold;
                    border-bottom: 1px solid gray;
                    padding-bottom: 5px;
                    margin-bottom: 10px;
                  "
            >Order Notes :</span
          ><br />
          <p style="margin-top: 3px">{{ order.orderNotes }}</p>
        </div>
        <div class="fotter">
          <p>
            For questions concerning this invoice, please contact <br />
            Phone: 07718180804 / 07831539028, Email: sales@ardunic.com
            <br />
            Ardunic inc. Baghdad / Karada <br />
            <a href="www.ardunic.com">www.ardunic.com</a>
          </p>
          <br />
          <p>
            يرجى الاطلاع على شروط الضمان للمنتج وحقوق المستخدم بزيارة صفحة (شروط
            الضمان) على موقعنا الالكتروني ولا تتحمل شركة اردونك تبعات عدم معرفة
            .الزبون بها
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loading from "@/views/Loading";
import Axios from "axios";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      orders: [],
      page: 1,
      size: 8,
      isLoading: false,
      statusType: {
        0: "Pending",
        1: "Completed",
        2: "Rejected",
        3: "Completed",
      },
      showPrintingPage: false,
      order: {},
    };
  },
  created() {
    Axios.get("https://api.ardunic.com/v1/user", {
      headers: {
        access_token: localStorage.getItem("token"),
      },
    }).then((res) => {
      this.$store.dispatch("initProfile", res.data.data);
    });
    this.getOrders();
  },
  watch: {
    page: function() {
      this.getOrders();
    },
  },
  methods: {
    async print(order) {
      await this.findOneOrder(order._id);
      this.showPrintingPage = true;
      document.getElementById("footer-section").style.display = "none";
      document.getElementById("fb-root").style.display = "none";
    },
    closePrint() {
      this.showPrintingPage = false;
      document.getElementById("footer-section").style.display = "inline-block";
      document.getElementById("fb-root").style.display = "inline-block";
    },
    async findOneOrder(id) {
      await Axios.get(`https://api.ardunic.com/v1/orders/${id}`, {
        headers: {
          access_token: localStorage.getItem("token"),
        },
      }).then(({ data }) => {
        this.order = data.data;
      });
      setTimeout(() => window.print(), 1000);
    },
    getOrders() {
      Axios.get(`https://api.ardunic.com/v1/orders?p=${this.page}&s=8`, {
        headers: {
          access_token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.orders = res.data.data;
      });
    },
    next() {
      this.page += 1;
    },
    previous() {
      this.page != 1 ? this.page-- : (this.page = 1);
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
  },
  computed: {
    user() {
      return this.$store.getters.getProfile;
    },
  },
};
</script>

<style scoped>
.orders {
  margin-top: 90px;
}

.circle {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 50%;
}

.title h1 {
  font-weight: 800;
  line-height: 0.8;
}

.title {
  padding-top: 20px;
}

.top-img {
  width: 110px;
}

.tbotn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  transition: all 0.3s ease;
  border: none;
  color: white;
}

thead tr th {
  width: 20px;
  height: 20px;
}

.type1 {
  width: 120px;
  height: 120px;
  border: none;
}

.middle {
  display: flex;
}

tr th,
tr td {
  text-align: center;
}

.table-card {
  padding: 20px 20px 0 20px;
  border: 1px solid #2a2a2a;
  border-radius: 20px;
}

tbody tr {
  border-bottom: 1px solid #000;
}

tbody tr:last-child {
  border-bottom: none;
}

.printing-section {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 999999999999999999999999999999999999999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fotter {
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 30px;
}
.invoice-box {
  max-width: 100%;
  height: 100%;
  margin: auto;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}
.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
  text-align: left;
}

.invoice-box table tr td:nth-child(2) {
  text-align: right;
}
.invoice-box table tr.top table td {
  padding-bottom: 20px;
}
.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}
.invoice-box table tr.information table td {
  padding-bottom: 40px;
}
.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}
.invoice-box table tr.details td {
  padding-bottom: 20px;
}
.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}
.invoice-box table tr.item.last td {
  border-bottom: none;
}
.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}
@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }
  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

.overflow-y {
  overflow-y: auto;
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
    sans-serif;
}
.rtl table {
  text-align: right;
}
.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>
